<template>
  <div class="product-container">
    <nav class="add-navigation">
      <div class="first-line line">
        <div class="field field-equal-size has-title">
          <date-time-picker
            header="START DATE"
            header_font_size="12"
            header_font_weight="700"
            header_font_color="#000"
            @getTime="getStartTime"
          ></date-time-picker>
        </div>
        <div class="field field-equal-size has-title">
          <date-time-picker
            header="END DATE"
            header_font_size="12"
            header_font_weight="700"
            header_font_color="#000"
            @getTime="getEndTime"
          ></date-time-picker>
        </div>
        <div class="field field-equal-size">
          <primary-select
            type="text"
            v-model="filter"
            placeholder="Select"
            style="margin-top: 20px"
          >
            <option :value="i" v-for="(i, k) in filters" :key="k">
              {{ i }}
            </option>
          </primary-select>
        </div>
      </div>
      <div class="second-line line">
        <div class="field field-equal-size">
          <primary-input
            class="search-input"
            type="text"
            v-model="sender"
            placeholder="Caller ID"
          />
        </div>
        <div class="field field-equal-size">
          <primary-input
            class="search-input"
            type="text"
            v-model="receiver"
            placeholder="Destination"
          />
        </div>
        <div class="field field-equal-size">
          <primary-input
            class="search-input"
            type="text"
            v-model="search_message"
            placeholder="Keyword"
          />
        </div>
        <div class="field btns field-full-size">
          <div class="search-btn" @click="getList">
            <primary-button>Search</primary-button>
          </div>
        </div>
      </div>
    </nav>
    <loader :loading="loading" v-if="loading" />
    <template v-if="!loading">
      <div class="table_div" style="width: 100%; overflow-x: auto">
        <table class="Invoice_table" style="margin-top: 50px">
          <thead>
            <tr class="Invoice_table_header">
              <th>Receiver</th>
              <th>Sender</th>
              <th style="width: 420px">Message</th>
              <th>Deliver Report</th>
              <th>Direction</th>
              <th class="created_on">Created On</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!smsLogs.length">
              <td
                valign="top"
                colspan="6"
                class="dataTables_empty"
                style="text-align: center"
              >
                No results found
              </td>
            </tr>
            <tr
              v-if="smsLogs.length > 0"
              class="line"
              v-for="(sms, k) in smsLogs"
              :key="k"
            >
              <th style="min-width: 100px">
                {{
                  sms.received
                    ? sms.received.receiver
                    : sms.sent
                    ? sms.sent.receiver
                    : ""
                }}
              </th>
              <th style="min-width: 100px">
                {{
                  sms.received
                    ? sms.received.sender
                    : sms.sent
                    ? sms.sent.sender
                    : ""
                }}
              </th>
              <th
                :title="sms.text.length > 49 ? sms.text : ''"
                style="min-width: 100px"
                class="text word-break"
              >
                {{ sms.text | shortText }}
              </th>
              <th style="min-width: 150px">{{ sms.dlr_state }}</th>
              <th style="min-width: 100px">
                {{ sms.received ? "received" : "sent" }}
              </th>
              <th class="created_on">{{ sms.time }}</th>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="per-page">
        <span class="filter_by custom-row">Show Per Page:</span>
        <div class="primary-input-container choose-type perPage">
          <primary-select
            type="text"
            @input="changePerPage"
            v-model="per_page" :is-cross="false"
            class="choose-type perPage"
            placeholder="Select"
          >
            <option :value="item" v-for="(item, key) in pages" :key="key">
              {{ item }}
            </option>
          </primary-select>
        </div>
      </div>
      <div class="buttons-wrapper">
        <pagination-component
          @change-page="changePage($event)"
          :page="Page"
          :perPage="per_page"
          :total="totalPages"
          :qnt="smsLogs.length"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { format } from "date-fns";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    DatePicker: () => import("vuejs-datepicker"),
    PrimaryInput: () => import("../../../components/Inputs/PrimaryInput.vue"),
    Loader: () => import("@/components/Loader.vue"),
    DateTimePicker: () => import("@/components/DateTime"),
  },
  data: () => ({
    filters: ["All", /*"Inbound Sms",*/ "Outbound Sms"],
    filter: "All",
    sender: "",
    receiver: "",
    Page: 0,
    search_message: "",
    total: null,
    period: {
      start: "",
      end: "",
    },
    pages: [10, 20, 50, 100, 200],
    per_page: 10,
    loading: true,
  }),
  computed: {
    ...mapGetters({
      smsList: "smses/getSmsList",
      totalPages: "smses/getTotalPages",
    }),
    smsLogs() {
      return this.smsList.map((sms) => ({
        text: sms.text,
        sent: sms.sent,
        time: format(sms.created_on, "YYYY:MM:DD HH:mm:ss"),
        received: sms.received,
        dlr_state: sms.dlr_state,
      }));
    },
  },
  filters: {
    shortText(txt) {
      return txt.length > 49 ? `${txt.slice(0, 49)}...` : txt;
    },
  },
  watch: {
    search_message: function () {
      this.Page = 0;
      //this.getList();
    },
    sender() {
      //this.getList();
    },
    receiver() {
      //this.getList();
    },
    filter: function () {
      this.Page = 0;
      //this.getList();
    },
    "period.start": function () {
      //this.getList();
    },
    "period.end": function () {
      //this.getList();
    },
  },
  async created() {
    await this.getList();
  },
  methods: {
    ...mapActions({
      viewSmses: "smses/getSmsListLog",
    }),
    reasetFilters() {
      this.filter = "All";
      this.sender = "";
      this.receiver = "";
      this.Page = 0;
      this.search_message = "";
      this.total = null;
      this.period = {
        start: "",
        end: "",
      };

      this.getList();
    },
    getStartTime(t) {
      this.period.start = new Date(t);
      console.log(new Date(t));
    },
    getEndTime(t) {
      this.period.end = new Date(t);
    },
    changePerPage(e) {
      this.Page = 0;
      this.getList();
    },
    changePage(page) {
      this.Page = page;
      this.getList();
    },
    async getList() {
      this.loading = true;
      let filter = "";
      if (this.filter === "Inbound Sms") {
        filter = true;
      } else if (this.filter === "Outbound Sms") {
        filter = false;
      }

      let query = {
        text: "*" + this.search_message.trim() + "*",
        page: this.Page || 0,
        per_page: this.per_page ? this.per_page : 10,
        is_received: filter,
        ani: "*" + this.sender + "*",
        recipient_number: "*" + this.receiver + "*",
        created_on_gt: this.period.start,
        created_on_lt: this.period.end,
        //company_uuid: this.$store.state.user.user.company_uuid
      };
      if (filter === "") {
        delete query.is_received;
      }
      if (this.sender === "") {
        delete query.ani;
      }
      if (this.receiver === "") {
        delete query.recipient_number;
      }
      if (this.period.start === "") {
        delete query.created_on_gt;
      }
      if (this.period.end === "") {
        delete query.created_on_lt;
      }
      if (this.search_message.trim() === "") {
        delete query.text;
      }

      await this.viewSmses(query);
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.search-input {
  margin-top: 20px !important;
}
.perPage {
  width: 120px !important;
  margin-bottom: -4px !important;
}
.custom-row {
  margin-left: 10px;
  width: 130px;
}
.primary-select-wrapper >>> .date-picker {
  width: 100%;
  min-height: 40px;
  display: block;
  background: transparent;
  padding-left: 15px;
  font-family: "Helvetica Neue";
  font-size: 14px;
  line-height: 25px;
  border: none;
}
table thead tr {
  background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
}
table thead tr th {
  color: white;
  padding-left: 10px;
}
@media (min-width: 1200px) {
  .container {
    max-width: 1280px;
  }
}
.primary-input-container:not(:first-child) {
  margin-left: 10px;
}
</style>

<style lang="scss" scoped>
.product-container {
  padding: 0 20px;

  .add-navigation {
    width: 100%;
    margin-top: 20px;
    padding: 15px;
    background: #fff;

    .line {
      display: flex;
      flex-wrap: wrap;
      width: 100%;

      .field-equal-size {
        width: 220px;
      }
      .field-full-size {
        flex-grow: 1;
        min-width: 120px;
      }
      .field:last-child {
        margin-right: 0px;
      }
      .field {
        margin-right: 20px;

        &.btns {
          display: flex;
          justify-content: flex-end;
          align-items: center;

          .search-btn {
            width: 120px;
          }
        }
      }
      .has-title {
        margin-top: -5px;
      }
    }
  }
  .per-page {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }
  .primary-input-container {
    width: 100%;
    margin-bottom: 15px;
    .pimary-input-title {
      color: #000000;
      font-family: "Helvetica Neue";
      font-size: 12px;
      font-weight: 900;
      letter-spacing: 0.21px;
      line-height: 15px;
      margin-bottom: 5px;
      text-transform: uppercase;
    }
    .primary-select-wrapper {
      box-sizing: border-box;
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
      height: 40px;
      border: 1px solid #edeef3;
      border-radius: 4px;
      background-color: #ffffff;

      ::placeholder {
        color: #55616e !important;
        opacity: 1;
      }
      .calendar-class {
        width: fit-content !important;
        height: fit-content !important;
        font-family: "Helvetica Neue";
        font-size: 14px;
      }
      .date-wrapper {
        width: 100%;
      }
      .vdp-datepicker {
        div {
          width: 100%;
        }
      }
      .date-picker {
        width: 100%;
        min-height: 40px;
        display: block;
        background: transparent;
        padding-left: 15px;
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 25px;
        border: none;
      }
      select:focus {
        border: 1px solid #51a3f3;
      }
      .icon-down {
        position: absolute;
        left: 100%;
        margin-left: -35px;
      }
    }
  }
}

table.Invoice_table {
  width: 100%;

  th {
    text-align: center;
  }
  .created_on {
    width: 190px;
  }
}
table thead tr {
  background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
  th {
    border-bottom-width: 2px;
    color: white;
    padding-left: 10px;
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6;
    border: 1px solid #dee2e6;
  }
}
table,
tr {
  width: 100%;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}

table {
  border-collapse: collapse;
}
.Invoice_table_popup {
  width: 75px;
}
.Invoice_table_header th {
  color: white;
  padding-left: 10px;
  border-bottom-width: 2px;
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  border: 1px solid #dee2e6;
  padding: 0.75rem;
}
.Invoice_table_header th:first-child {
  padding-left: 20px;
  padding-right: 30px;
  width: 14%;
}
tbody th:first-child {
  padding-left: 20px;
  padding-right: 30px;
}
.popup_content {
  display: none;
}
.popup_cta {
  cursor: pointer;
  padding-right: 5px;
}
.Invoice_table_popup {
  text-align: right;
  position: relative;
}
tbody th {
  height: 40px;
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  font-size: 14px;
  line-height: 20px;
  padding: 12px 10px;
}

tbody {
  th.icon {
    padding: 7px 20px 7px 0;

    .edit {
      margin-right: 20px;
    }
  }

  .img-container {
    padding: 7px 0;
  }

  th.text {
    max-width: 450px;
  }
}

.Invoice_price {
  font-family: "Helvetica Neue";
}

.Invoice_table_popup.active .popup_content {
  display: block;
  position: absolute;
  right: 0;
  width: 240px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.1);
  padding-left: 0;
  list-style-type: none;
  text-align: left;
}

.Invoice_table_popup.active .popup_content a {
  color: #55616e;
  font-size: 16px;
  line-height: 20px;
  text-decoration: none;
  font-family: "Helvetica Neue";
  padding: 10px 15px;
  display: inline-block;
}

.popup_image {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 8px;
}

th.user_active:after {
  content: "";
  height: 10px;
  width: 10px;
  background-color: #24e2b8;
  position: absolute;
  border-radius: 50%;
  left: 12px;
  top: 20px;
}

th.user_active {
  text-align: left;
  position: relative;
  padding-left: 35px;
}

th .svg-grey {
  cursor: pointer;
  fill: #55616e;
}

th .callflow {
  font-size: 12px;
  width: 86px;
  height: 20px;
  padding-top: 0px;
  float: right;
  line-height: 20px;
}

th .number-icon {
  height: 16px;
  width: 16px;
  margin-right: 8px;
}
@media (max-width: 1400px) {
  table.Invoice_table {
    width: 1150px;
  }
}
.table_div::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}
</style>

